import { Button } from '@fluentui/react-components';
import { ErrorPageContainer } from './styles/ServerErrorPage.styled';
import servererror from '../assets/servererror.svg';

export const ServerErrorPage = () => {
  return (
    <ErrorPageContainer>
      <img src={servererror}></img>
      <h1>We&apos;re sorry, we&apos;ve run into an issue</h1>
      <Button appearance="primary" onClick={() => window.location.reload()}>
        Restart
      </Button>
      <p>
        If that doesn&apos;t work, try <a>signing out</a> and back in.
      </p>
    </ErrorPageContainer>
  );
};
